import { IShift } from './';
import { BaseService, IGetList } from '../base/base.service';
import { AppService } from '../main/app.service';
import { BaseEntity } from '../base/base.entity';
import * as angular from 'angular';

export class IEmployeeSkill extends BaseEntity {
    employeeId: string
    skillId: string;
    skillName: string;
    start: any;
    end: any;
    documentOfProofId: string;
    comment: string;
}

export class IBlob {
    filenameWithExtention: string
}

export class EmployeeSkillsService extends BaseService<IEmployeeSkill> {
    constructor(Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'hr/employeeSkill');
    }

    public postBlob(id, file: any): ng.IPromise<any> {

        // Create FormData to send in the request
        var formData = new FormData();
        formData.append('file', file, file.name);

        return this.Restangular.one('hr/employeeSkill', id)
            .withHttpConfig({ transformRequest: angular.identity })
            .customPOST(formData, 'blobs', undefined, { 'Content-Type': undefined })
            .then((item: Restangular.IElement) => {
                this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
                this.item = item.plain();
                return item.plain();
            })
            .catch((error) => {
                this.AppService.NotifyService.error('Foutmelding', error.data);
                return error;
            });
    }


    public getBlobs(id): ng.IPromise<IGetList<IBlob>> {
        return this.Restangular.one('hr/employeeSkill', id).all('blobs').customGET('').then((collection: Restangular.ICollection) => {
            return collection.plain();
        })
    }

    public getBlob(id, blobid): ng.IPromise<Blob> {
        this.Restangular.setFullResponse(true);
        return this.Restangular.one('hr/employeeSkill', id).one('blobs', blobid).customGET('').then((response) => {
            return new Blob([response.data], { type: response.headers('Content-Type') });
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/services/employeeSkills.service.ts